export function stopCamera(selector) {
  const video = document.querySelector(selector);

  if (video) {
    for (const track of video?.srcObject?.getTracks()) {
      track.stop();
      track.enabled = false;
    }
    video.srcObject = null;
  }
}